import React, { useContext } from "react";
import {
  _t,
  getSystemSettings,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { SettingsContext } from "../../../../../contexts/Settings";
import { UserContext } from "../../../../../contexts/User";
import "./stock.css"

const GatePassPrint = ({
  name,
  documentDate,
  newGatePass,
  newRow,
  print,
}) => {
  const { t } = useTranslation();
  const {
    //common
    generalSettings,
  } = useContext(SettingsContext);
  const { authUserInfo } = useContext(UserContext);

  return (    
    <>
      {/* print */}
      <div className="d-none">
        <div ref={print}>
          {newGatePass && (
            <div className="fk-print" style={{margin:"20px 25px"}}>
              <div className="">
                <div className="row">
                  <div className="col-12">
                      <div className="mx-auto" style={{ width: "90px" }}>
                        <img
                        src={`${getSystemSettings(
                          generalSettings,
                          "type_logo"
                        )}`}
                        style={{ width: "100%" }}
                        />
                      </div>
                      <div className="my-2 xlg-print-text-stock print-text-stock text-center text-capitalize print-text-stock--bold">
                        {name}
                      </div>

                      <div className="mt-4 mx-2 row my-2 ml-0 print-text-stock text-capitalize">
                        <div className="col-6 print-text-stock--bold">Document No: {newGatePass.document_identity}</div>
                        <div className="col-6 print-text-stock--bold">Document Date : {documentDate && documentDate?.toDateString()}</div>
                      </div>
                    
                    
                      <div className="row mx-2 my-2 ml-0 print-text-stock text-capitalize">
                        {newGatePass.branch ? (
                          <div className="col-6 print-text-stock--bold">
                            Branch Name :{" "}
                            {newGatePass.branch?.name}
                          </div>
                          ) : ""
                        }
                        {newGatePass.type ? 
                          <div className="col-6 print-text-stock--bold">
                            Type :{" "}
                            {newGatePass.type && newGatePass.type}
                          </div>
                        : ""}
                      </div> 

                      <div className="row mx-2 my-2 print-text-stock text-capitalize ml-0">
                        {authUserInfo.details ? (
                          <div className="col-6 print-text-stock--bold">
                            User Name :{" "}
                            {authUserInfo.details?.name}
                          </div>
                          ) : ""
                        }
                        {newGatePass.taker_name ? (
                          <div className="col-6 print-text-stock--bold">
                            Taker Name :{" "}
                            {newGatePass.taker_name}
                          </div>
                          ) : ""
                        }
                      </div>                 

                      {newGatePass.remarks ? 
                      <div className="row mx-2 my-2 print-text-stock--bold print-text-stock text-capitalize ml-0">
                        Remarks :{" "}
                        <div className="text-preline">
                          {newGatePass.remarks && newGatePass.remarks}
                        </div>                    
                      </div> : null}

                      {newRow && [
                      newRow.length > 0 && (
                        <div className=" my-3">
                          <table className="table table-bordered-sm table-hover ">
                            <thead className="align-middle">
                              <tr>
                                <th
                                  scope="col"
                                  className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border table-Child"
                                  style={{minWidth:"180px"}}
                                >
                                  {_t(t("Name"))}
                                </th>
                                <th
                                  scope="col"
                                  className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                                >
                                  {_t(t("Qty"))}
                                </th>
                              </tr>
                            </thead>

                            <tbody className="align-middle">
                              {newRow?.map((item, index) => {                                
                                return (
                                  <tr className="align-middle" key={index}>
                                      <td className="print-text-stock text-capitalize border-dark border-1 align-middle text-center">
                                        {item?.item_name}
                                      </td>
                                      <td className="print-text-stock text-capitalize border-dark border-1 align-middle text-center">                                    
                                        {Number(item?.qty)}
                                      </td>                  
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      ),
                      ]} 

                      <div className="mt-5 row">
                        <div className="col-6 d-flex align-item-center">
                          <div className="col-3">Taker Signature</div> 
                          <div className="col-8 ml-2 border-bottom border-1 border-dark"></div>
                        </div>
                        <div className="col-6 d-flex align-item-center">
                          <div className="col-3">Company Signature</div> 
                          <div className="col-8 ml-2 border-bottom border-1 border-dark"></div>
                        </div>
                      </div>                                     
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default GatePassPrint;
